function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchPolizaEndorsements, getIndexQueryKey } from "./actions/PolizaEndorsementActions";
import PolizaEndorsementListItem from "./PolizaEndorsementListItem"; //import ListPolizaRenewal from "./ListPolizaRenewal";
//import { IPolizaRenewal } from "../ISchema";
//import ModalPolizaRenewal from "./components/ModalPolizaRenewal";

var IndexPolizaEndorsements = function IndexPolizaEndorsements(props) {
  var poliza_id = props.poliza_id,
      admin = props.admin;

  var _React$useReducer = React.useReducer(function (x) {
    return x + 1;
  }, 0),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      ignored = _React$useReducer2[0],
      forceUpdate = _React$useReducer2[1];

  var _useQuery = useQuery({
    queryKey: getIndexQueryKey(poliza_id),
    queryFn: function queryFn() {
      return fetchPolizaEndorsements(poliza_id);
    }
  }),
      data = _useQuery.data,
      error = _useQuery.error,
      isLoading = _useQuery.isLoading;

  if (isLoading) return /*#__PURE__*/React.createElement("p", null, "Cargando endosos...");
  if (error) return /*#__PURE__*/React.createElement("p", null, "Error!");
  var polizaEndorsements = data.poliza_endorsements;

  var renderPolizaEndorsements = function renderPolizaEndorsements() {
    return polizaEndorsements.map(function (polizaEndorsement) {
      return /*#__PURE__*/React.createElement(PolizaEndorsementListItem, {
        key: polizaEndorsement.id,
        polizaEndorsement: polizaEndorsement,
        onUpdate: forceUpdate,
        admin: admin
      });
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, polizaEndorsements && polizaEndorsements.length > 0 && renderPolizaEndorsements(), polizaEndorsements && polizaEndorsements.length === 0 && /*#__PURE__*/React.createElement("h3", null, "No se han encontrado endosos.")));
};

export default IndexPolizaEndorsements;